"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmsComponentMapper = exports.mapCmsComponents = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("./utils");
function mapCmsComponents({ dynamicPageDataArray, componentMapping, propKey, ItemSeparator }) {
    if (!dynamicPageDataArray ||
        !dynamicPageDataArray.length ||
        !componentMapping ||
        !Object.keys(componentMapping).length) {
        return [react_1.default.createElement("div", { className: "mw-cms-map-not-found" })];
    }
    const numDynamicElements = dynamicPageDataArray.length;
    const elements = [];
    dynamicPageDataArray.forEach((_item, i) => {
        // We are extracting the _type property from the object via spreading
        // rather than deleting to support working with sealed objects
        const { _type } = _item, item = __rest(_item, ["_type"]);
        const itemLength = Object.keys(item).length;
        if (item && itemLength) {
            for (const key in item) {
                if (Object.prototype.hasOwnProperty.call(item, key)) {
                    if (componentMapping[key]) {
                        const Component = componentMapping[key];
                        const pageData = item[key];
                        const pageDataProps = propKey ? { [propKey]: pageData } : pageData;
                        const afterSectionVerticalSpacerProvided = (i < numDynamicElements - 1 || i < itemLength - 1) && !!ItemSeparator;
                        elements.push(Component((0, utils_1.assign)({
                            key: `${key}-${i}`,
                            afterSectionVerticalSpacerProvided,
                            componentMapperIndex: i,
                            componentMapperItemLength: numDynamicElements
                        }, pageDataProps)));
                        //place a vertical space separater between items
                        if (afterSectionVerticalSpacerProvided && ItemSeparator) {
                            elements.push(ItemSeparator({ key: `${key}-${i}-separator` }));
                        }
                    }
                    else {
                        console.log(`No mapping found for key ${key}`);
                    }
                }
            }
        }
    });
    return elements;
}
exports.mapCmsComponents = mapCmsComponents;
/**
 * CmsComponentMapper is to map different content types coming from a
 * Functional Component in the Epic CMS to their associated React Component.
 * It processes `dynamicPageDataArray` and maps to the associated React
 * Component as specified in `elementMapping` based on the key
 */
const CmsComponentMapper = ({ dynamicPageDataArray, componentMapping, propKey, ItemSeparator, reactKey }) => {
    const elements = mapCmsComponents({
        dynamicPageDataArray,
        componentMapping,
        propKey,
        ItemSeparator
    });
    return react_1.default.createElement(react_1.Fragment, { key: reactKey !== null && reactKey !== void 0 ? reactKey : null }, elements);
};
exports.CmsComponentMapper = CmsComponentMapper;
//# sourceMappingURL=CmsComponentMapper.js.map